import { PATH_BUILDER } from 'constants/actionTypes';
import { EVENTS } from 'constants/config';
import reduceContent from './content';
import reduceUI from './ui';
import reduceTagging from './tagging';
import reduceOwnerships from './ownership';
import reduceEditingContent from './editingContent';
import reduceRelatedUrls from './relatedUrls';
import reduceLibraryContents from './libraryContents';
import reduceReporting from './reporting';
import reduceLoadingContent from './loadingContent';
import { getPathRevisionData } from '../../selectors/pathBuilder';

const pathBuilderReducer = (state = {}, action = {}) => {
  const updateState = changes => ({ ...state, ...changes });
  switch (action.type) {
    case PATH_BUILDER.PATH.UPDATE:
      return updateState({
        ...action.changes,
      });

    case PATH_BUILDER.PATH.UPDATE_IN_PROGRESS:
      return updateState({ updateInProgress: true });

    case PATH_BUILDER.PATH.UPDATE_SUCCESS:
      return updateState({ updateInProgress: false });

    case PATH_BUILDER.PATH.UPDATE_FAILURE:
      return updateState({ updateInProgress: false, updateError: true });

    case PATH_BUILDER.PATH.UPDATE_FAILURE_DISMISS:
      return updateState({ updateError: false });

    case PATH_BUILDER.PATH.PUBLISH:
      return updateState({
        publishedAt: { date: action.date, user: action.user },
      });

    case PATH_BUILDER.PATH.SAVE_REVISION:
      return updateState({
        lastRevision: getPathRevisionData(state),
      });

    case PATH_BUILDER.PATH.RESTORE_REVISION:
      return updateState({
        ...state.lastRevision,
        contents: reduceContent(
          state.contents,
          action,
          state.lastRevision.contents,
        ),
      });

    case PATH_BUILDER.PATH.SET_ESTIMATED_MINUTES_TO_COMPLETE:
      return updateState({
        estimatedMinutesToComplete: action.estimatedMinutesToComplete,
      });

    case PATH_BUILDER.UI.SET_MODE:
      return updateState({ mode: action.mode });

    case PATH_BUILDER.PATH.TOGGLE_EDITING_DESCRIPTION:
      return updateState({
        editingDescription: !state.editingDescription,
      });

    case PATH_BUILDER.PATH.TOGGLE_EDITING_ORDER_ENFORCEMENT:
      return updateState({
        editingOrderEnforcement: !state.editingOrderEnforcement,
      });

    case PATH_BUILDER.CONTENT.ADD:
      return updateState({
        contents: reduceContent(state.contents, action),
        editingContent: reduceEditingContent(state.editingContent, action),
      });
    case PATH_BUILDER.CONTENT.UPDATE:
    case PATH_BUILDER.CONTENT.REMOVE:
    case PATH_BUILDER.CONTENT.REORDER:
    case PATH_BUILDER.CONTENT.PERSIST:
      return updateState({
        contents: reduceContent(state.contents, action),
        editingContent: reduceEditingContent(state.editingContent, action),
      });

    case PATH_BUILDER.CONTENT.TOGGLE_EDITING:
      return updateState({
        editingContent: reduceEditingContent(state.editingContent, action),
      });

    case PATH_BUILDER.PATH.TOGGLE_EDITING_MODE: {
      global.pubsub.publish(EVENTS.SET_STEP_CONNECTOR_POSITION);
      return updateState({
        editingContent: undefined,
        mode: state.mode === 'edit' ? 'view' : 'edit',
      });
    }

    case PATH_BUILDER.CONTENT.TOGGLE_DRAGGING:
      return updateState({
        isDraggingContent: !state.isDraggingContent,
      });

    case PATH_BUILDER.UI.TOGGLE_EDITING_BY_NAME:
      return updateState({
        ui: reduceUI(state.ui, action),
      });

    case PATH_BUILDER.TAGGING.CREATE:
    case PATH_BUILDER.TAGGING.REMOVE:
    case PATH_BUILDER.TAGGING.TAG_ALL_CONTENT:
      return updateState({
        taggings: reduceTagging(state.taggings, action),
      });

    default: {
      return {
        ...state,
        ui: reduceUI(state.ui, action),
        taggings: reduceTagging(state.taggings, action),
        ownerships: reduceOwnerships(state.ownerships, action),
        contents: reduceContent(state.contents, action),
        relatedUrls: reduceRelatedUrls(state.relatedUrls, action),
        libraryContents: reduceLibraryContents(state.libraryContents, action),
        reporting: reduceReporting(state.reporting, action),
        loadingContent: reduceLoadingContent(state.loadingContent, action),
      };
    }
  }
};

export default pathBuilderReducer;
